var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1410126704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 660 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99805 12.6875C10.1392 12.6875 12.6855 10.1411 12.6855 7C12.6855 3.85888 10.1392 1.3125 6.99805 1.3125C3.85693 1.3125 1.31055 3.85888 1.31055 7C1.31055 10.1411 3.85693 12.6875 6.99805 12.6875ZM6.99805 14C10.864 14 13.998 10.866 13.998 7C13.998 3.13401 10.864 0 6.99805 0C3.13205 0 -0.00195312 3.13401 -0.00195312 7C-0.00195312 10.866 3.13205 14 6.99805 14Z",
    fill: "#7D899C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1410126812"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 659",
    cx: 7.03271,
    cy: 4.375,
    r: 0.75,
    fill: "#7D899C",
    stroke: "#7D899C",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99805 6.34375C7.36048 6.34375 7.6543 6.63756 7.6543 7L7.6543 9.625C7.6543 9.98744 7.36048 10.2813 6.99805 10.2813C6.63561 10.2813 6.3418 9.98744 6.3418 9.625L6.3418 7C6.3418 6.63756 6.63561 6.34375 6.99805 6.34375Z",
    fill: "#7D899C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoNew);
export default __webpack_public_path__ + "static/media/InfoNew.88d0a2af0e3363fe17f3f15f316d63fa.svg";
export { ForwardRef as ReactComponent };